export default __webpack_public_path__ + "static/media/sav7.2772b614.jpg";